import getDefaultValues from './DefaultValues';

/**
 * Returns the keys that are available as used search options
 */
export default function() {
    const defaultUserOptions = getDefaultValues();
    let availableKeys = [];
    Object.keys(defaultUserOptions).forEach(key => {
        availableKeys.push(key);
    });
    return availableKeys;
}